/* FizzyIQ — easter eggs. Five small, decorative discoveries (trimmed from
   ten per Sam 2026-06-11; Konami, logo wiggle, "fizzy" trail, social wave,
   and the bottom-of-page toast were cut). Hard rules: no layout shift,
   overlays are pointer-events: none, listeners are passive/cheap, missing
   targets are skipped silently, nothing touches cart/checkout/forms.

   The five:
   1. 5 quick clicks on the hero pouches  → fruit confetti (once per session)
   2. Styled console note for the curious
   3. Hovering the footer logo for 2.5s   → whispered tagline toast
   4. Double-click the circled "tasty"    → the circle redraws + 😋
   5. Selecting text containing "focus"   → a small ✨ where you released   */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ss(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function spawn(tag, className, styles, ttl) {
    var el = document.createElement(tag);
    el.className = className;
    el.setAttribute('aria-hidden', 'true');
    for (var k in styles) el.style.setProperty(k, styles[k]);
    document.body.appendChild(el);
    window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, ttl);
    return el;
  }

  var toastEl = null;
  var toastTimer = 0;
  function toast(msg, ms) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'egg-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 4000);
  }

  /* 1 ── 5 quick clicks on the hero pouches → fruit confetti, once per session */
  (function () {
    var banner = document.querySelector('.rvh-banner');
    if (!banner) return;
    var clicks = 0, timer = 0;
    banner.addEventListener('click', function () {
      clicks++;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { clicks = 0; }, 1500);
      if (clicks >= 5 && !ss('egg-party')) {
        ss('egg-party', '1');
        clicks = 0;
        if (REDUCE) return;
        var fruit = ['🍒', '🍊', '🍓', '🍉'];
        for (var i = 0; i < 26; i++) {
          var el = spawn('span', 'egg-fruit', {
            left: ((i * 67) % 100) + 'vw',
            '--egg-dur': (2.2 + ((i * 17) % 16) / 10) + 's',
            '--egg-spin': (((i * 97) % 520) - 260) + 'deg',
            'animation-delay': ((i * 41) % 600) + 'ms'
          }, 3800);
          el.textContent = fruit[i % fruit.length];
        }
        toast('Flavor party. All four made it. 🍒🍊🍓🍉');
      }
    });
  })();

  /* 2 ── A note for whoever opens the console */
  try {
    console.log(
      '%c FIZZY IQ %c bubbly brain booster ',
      'background:#16264D;color:#fff;font-weight:700;padding:4px 8px;border-radius:6px 0 0 6px;',
      'background:#FC5F2B;color:#fff;padding:4px 8px;border-radius:0 6px 6px 0;'
    );
    console.log('You found the console. Curiosity looks good on you — a few more of these are hidden around the site. 🫧');
  } catch (e) {}

  /* 3 ── Hovering the footer logo 2.5s → whispered tagline */
  (function () {
    var mark = document.querySelector('.ff-top .brand-mark');
    if (!mark) return;
    var hold = 0;
    mark.addEventListener('mouseenter', function () {
      hold = window.setTimeout(function () {
        toast('Psst — bubbly brain booster. But you knew that. 🫧', 3200);
      }, 2500);
    });
    mark.addEventListener('mouseleave', function () { window.clearTimeout(hold); });
  })();

  /* 4 ── Double-click the circled "tasty" → the pen redraws the circle */
  (function () {
    var circled = document.querySelector('.rvpr-circled');
    if (!circled) return;
    circled.addEventListener('dblclick', function (e) {
      circled.classList.remove('egg-redraw');
      void circled.offsetWidth;
      circled.classList.add('egg-redraw');
      var s = spawn('span', 'egg-spark', { left: e.clientX + 'px', top: e.clientY + 'px' }, 1000);
      s.textContent = '😋';
    });
  })();

  /* 5 ── Selecting text that contains "focus" → a small sparkle */
  (function () {
    var lastSpark = 0;
    document.addEventListener('pointerup', function (e) {
      var now = Date.now();
      if (now - lastSpark < 30000) return;
      var sel = window.getSelection && window.getSelection();
      var text = sel ? String(sel.toString() || '') : '';
      if (text.toLowerCase().indexOf('focus') === -1) return;
      lastSpark = now;
      var s = spawn('span', 'egg-spark', { left: e.clientX + 'px', top: e.clientY + 'px' }, 1000);
      s.textContent = '✨';
    }, { passive: true });
  })();
})();
